module.exports = __webpack_public_path__ + "img/115ne.e90edee5.svg";